import React from "react";
import NoDataChartSvg from "../../../assets/NoDataSvg/noDataChartSvg";

const VmoNoDataChart = ({ imageSrc, noDataText, noDataSubText }) => {
  return (
    <div className="no-data-design">
      {imageSrc ? (
        <img style={{ maxWidth: "100%" }} src={imageSrc} />
      ) : (
        <NoDataChartSvg />
      )}

      <p>{noDataText || ""}</p>
      <span>{noDataSubText || ""}</span>
    </div>
  );
};

export default VmoNoDataChart;
